import React, { useContext } from 'react'
import { SectionSelectWithRibbon } from '../../../Core/Form/FormComponents'
import { billing_period_options } from '../../../../Constants'
import { BillingPeriod } from '../../../../models/insurance-models/InsuranceBillingPeriodModel'
import { SessionContextStore } from '../../../../context/SessionContext'
import { StatesContextStore } from '../../../../context/StatesContext'

export const BillingPlanSpecialSelect = ({ value, discounts, onChange }) => {
  const statesContextStore = useContext(StatesContextStore)
  const sessionContext = useContext(SessionContextStore)

  return (
    <SectionSelectWithRibbon
      onChange={onChange}
      name="billing-period"
      GTMname="billing-plan"
      value={value}
      buttons={Object.values(billing_period_options).filter(
        x =>
          !(
            x.value === BillingPeriod.SIXMONTHS &&
            statesContextStore.new_estimated_flow.includes(sessionContext.user.administrativeDivision)
          )
      )}
      shouldHaveDivider={false}
      discounts={discounts}
    />
  )
}
